// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `a {
    text-decoration: none;
}

/* ---------- ساختار اصلی ---------- */
.app {
    padding: 16px;
    display: flex;
    gap: 16px;
    max-width: 1400px;
    margin: 32px auto;
    padding: 0 12px;
}

/* Main content */
.main {
    flex-grow: 1;
    height: auto;
    max-height: 90vh;
    transition: width 0.3s ease;
    background: #fff;
    padding: 16px;
    width: 1100px;
    border-radius: 20px;
      box-shadow: 0 10px 25px rgba(0, 0, 0, 0.05);

}

.sidebar {
    background: #ffffff;
    border-radius: 20px;
    padding: 12px;
    display: flex;
    flex-direction: column;
    gap: 8px;
    width: 250px;
    transition: width 0.3s ease;
   position: sticky;
  top: 20px; /* فاصله از بالای صفحه */
    box-shadow: 0 10px 25px rgba(0, 0, 0, 0.05);

}



.sidebar.closed {
    width: 60px;
}

/* وقتی سایدبار بسته شد */
.sidebar.closed .nav a {
  justify-content: center;
  gap: 0;
  position: relative; 
}

/* متن label مخفی می‌شود */
.sidebar.closed .nav a .label {
  opacity: 0;
  width: 0;
  overflow: hidden;
  transition: opacity 0.3s, width 0.3s;
}

/* استایل تولتیپ */
.sidebar.closed .nav a::after {
  content: attr(data-label); 
  position: absolute;
  left: 100%;  
  top: 50%;
  transform: translateY(-50%);
  background: #333;
  color: #fff;
  padding: 4px 8px;
  border-radius: 4px;
  white-space: nowrap;
  font-size: 12px;
  opacity: 0;
  pointer-events: none;
  transition: opacity 0.3s ease, transform 0.3s ease;
  margin-left: 8px; 
}

/* نمایش تولتیپ در هاور */
.sidebar.closed .nav a:hover::after {
  opacity: 1;
  transform: translateY(-50%) translateX(0);
}

.sidebar.closed .toggle-btn {
    margin-right: -10px;
}


/* برند */
.brand {
    display: flex;
    align-items: center;
    justify-content: space-between;
    gap: 10px;
}

.brand .logo {
    font-size: 24px;
}

.brand h1 {
    font-size: 16px;
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
    transition: opacity 0.3s;
}

.brand h1.hidden {
    opacity: 0;
}

/* دکمه تغییر وضعیت */
.toggle-btn {
    background: none;
    border: none;
    cursor: pointer;
    font-size: 20px;
}

/* ناوبری */
.nav {
    display: flex;
    flex-direction: column;
    gap: 12px;
    /* فاصله بین لینک‌ها */
}

.nav a {
    display: flex;
    align-items: center;
    gap: 12px;
    /* فاصله بین آیکن و متن */
    padding: 8px 12px;
    border-radius: 12px;
    color: #333;
    text-decoration: none;
    transition: background 0.2s;
}



.nav a .label {
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
    transition: opacity 0.3s;
}

.sidebar.closed .nav a .label {
    opacity: 0;
}


.nav a:hover {
    background-color: rgba(234, 108, 34, 0.7);

    color: #ffff;
}



.hamburger {
    cursor: pointer;
    background-color: #EA6C22;
    border-radius: 8px;

    display: flex;
    /* برای هم‌ترازی محتوای آیکن */
    align-items: center;
    justify-content: center;
}

.hamburger input {
    display: none;
}

.hamburger svg {
    /* The size of the SVG defines the overall size */
    height: 1.5em;
    /* Define the transition for transforming the SVG */
    transition: transform 600ms cubic-bezier(0.4, 0, 0.2, 1);
}

.line {
    fill: none;
    stroke: rgb(255, 255, 255);
    stroke-linecap: round;
    stroke-linejoin: round;
    stroke-width: 3;
    /* Define the transition for transforming the Stroke */
    transition: stroke-dasharray 600ms cubic-bezier(0.4, 0, 0.2, 1),
        stroke-dashoffset 600ms cubic-bezier(0.4, 0, 0.2, 1);
}

.line-top-bottom {
    stroke-dasharray: 12 63;
}

.hamburger input:checked+svg {
    transform: rotate(-45deg);
}

.hamburger input:checked+svg .line-top-bottom {
    stroke-dasharray: 20 300;
    stroke-dashoffset: -32.42;
}


/* Aside & Grid */
.aside {
    display: flex;
    flex-direction: column;
    gap: 16px;
}

.grid {
    display: grid;
    grid-template-columns: 1fr;
    gap: 16px;
}

.card {
    background: var(--panel);
    border-radius: 20px;
    padding: 16px;
}

/* ---------- ساختار اصلی هدر ---------- */
.card-header {
  display: flex;
  align-items: center;
  justify-content: space-between;
  margin-bottom: 12px;
  flex-wrap: wrap; /* برای ریسپانسیو */
  gap: 1rem;
}

/* عنوان */
.card-header .card-title {
  font-size: 1.3rem;
  font-weight: 600;
  color: #222;
}

/* بخش راست شامل سرچ و دکمه‌ها */
.header-actions {
  display: flex;
  align-items: center;
  gap: 1rem;
  flex-wrap: wrap;
}



.button-group {
    display: flex;
    gap: 8px !;
}

.muted {
    color: var(--muted);
    font-size: 12px;
}

/* برند و ناوبری عمومی */
.brand {
    display: flex;
    align-items: center;
    gap: 10px;
    padding: 10px 12px;
}

.brand .logo {
    width: 34px;
    height: 34px;
    border-radius: 12px;
    background: #e5e7eb;
    display: grid;
    place-items: center;
    font-weight: 700;
}

.brand h1 {
    font-size: 20px;
    margin: 0;
}

.nav a {
    color: #111827;
    padding: 10px 12px;
    border-radius: 12px;
    display: flex;
    align-items: center;
    /* مرکز کردن عمودی */
    gap: 12px;
    /* فاصله بین آیکن و متن */
    cursor: pointer;
    transition: color 0.3s, background 0.3s;
}

.nav a .dot {
    display: flex;
    /* برای هم‌ترازی محتوای آیکن */
    align-items: center;
    justify-content: center;
    font-size: 20px;
    /* سایز آیکن را می‌توانید تنظیم کنید */
}

.nav a .label {
    display: inline-block;
    font-size: 16px;
}



.sidebar.closed .nav a .label {
    opacity: 0;
    width: 0;
    overflow: hidden;
    transition: opacity 0.3s, width 0.3s;
}

.nav a.active {
    background-color: rgba(234, 108, 34, 1);
    color: white;
}


/* جستجو */
.search {
    flex: 1 1;
    position: relative;
}

.search input {
    width: 100%;
    padding: 12px 44px 12px 16px;
    border-radius: 999px;
    border: 1px solid var(--ring);
    outline: none;
    background: #fff;
    box-shadow: inset 0 1px 0 rgba(0, 0, 0, .03);
}

/* دکمه‌ها */
.btn {
    border: 0;
    padding: 10px 16px;
    border-radius: 999px;
    background: var(--mainColor);
    color: #fff;
    cursor: pointer;
    font-weight: 600;
    box-shadow: 0 8px 18px rgba(17, 24, 39, .2);
    font-family: Estedad-Regular;
    font-size: 13px;
}

/* Pill */
.pill {
    background-color: #f0f0f0;
    padding: 8px 15px;
    border-radius: 25px;
    cursor: pointer;
    display: inline-flex;
    align-items: center;
    gap: 5px;
    -webkit-user-select: none;
            user-select: none;
    font-family: Estedad-Regular;
    position: relative;
    min-width: 120px;
}

.pill .arrow {
    font-size: 12px;
}

/* Overview */
.overview {
    display: grid;
    grid-template-columns: 1fr 1fr;
    gap: 12px;
}

.stat {
    background: #fff;
    border-radius: 16px;
    padding: 18px;
    border: 1px solid var(--ring);
}

.stat .value {
    font-size: 44px;
    font-weight: 800;
    letter-spacing: -1px;
}

.delta {
    display: inline-flex;
    align-items: center;
    gap: 6px;
    font-weight: 600;
    padding: 6px 8px;
    border-radius: 10px;
}

.delta.up {
    background: rgba(16, 185, 129, .12);
    color: var(--green);
}

.delta.down {
    background: rgba(239, 68, 68, .12);
    color: var(--red);
}

/* Bars */
.bars {
    display: flex;
    align-items: flex-end;
    gap: 10px;
    height: 180px;
    padding: 16px;
    background: linear-gradient(180deg, #fafafb, #f7f7f8);
    border-radius: 16px;
    border: 1px solid var(--ring);
}

.bar {
    flex: 1 1;
    background: #e5e7eb;
    border-radius: 12px;
    position: relative;
    overflow: hidden;
}

.bar>i {
    position: absolute;
    bottom: 0;
    left: 0;
    right: 0;
    display: block;
    height: 60%;
    background: linear-gradient(180deg, #a7f3d0, #34d399);
}

/* Vendors */
.vendors {
    display: flex;
    flex-direction: column;
    gap: 12px;
}

.vendor {
    display: flex;
    align-items: center;
    justify-content: space-between;
    gap: 16px;
    padding: 12px 16px;
    border-radius: 12px;
    border: 1px solid #e5e7eb;
    background: #f9fafb;
}

.vendor .title {
    flex: 2 1;
    display: inline-block;
    max-width: 200px;
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
}

.vendor .edit-product {
    padding: 4px 8px;
    font-size: 12px;
    border-radius: 8px;
    border: none;
    background: var(--mainColor);
    color: #fff;
    cursor: pointer;
    margin-left: 8px;
    box-shadow: 0 4px 10px rgba(59, 130, 246, 0.3);
}

/* Product & Visitor Lists */
.product-list-bnv,
.visitor-list-bnv {
    list-style: none;
    padding: 0;
    margin: 0 0 15px 0;
}


/* Modal */
.modal-overlay {
    position: fixed;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
    background: rgba(0, 0, 0, 0.25);
    backdrop-filter: blur(5px);
    display: flex;
    justify-content: center;
    align-items: center;
    z-index: 999;
    opacity: 0;
    animation: fadeOverlay 0.4s ease forwards;
    padding: 20px;
    box-sizing: border-box;
}

.modal {
  background: #fff;
  padding: 20px;
  border-radius: 16px;
  width: 50%;
  max-width: 4000px;
  max-height: 90vh;
  overflow-y: auto;
  box-shadow: 0 10px 30px rgba(0, 0, 0, 0.2);
  transform: translateY(50px);
  opacity: 0;
  animation: slideUp 0.5s cubic-bezier(0.22, 1, 0.36, 1) forwards;
  scrollbar-width: thin;
  scrollbar-color: rgba(100, 100, 100, 0.5) transparent;
}

/* Animation */
@keyframes slideUp {
  0% {
    transform: translateY(50px);
    opacity: 0;
  }
  100% {
    transform: translateY(0);
    opacity: 1;
  }
}



@media (max-width: 768px) {

  
.modal {

    width: 100%;

}
}
.modal::-webkit-scrollbar {
    width: 6px;
}

.modal::-webkit-scrollbar-track {
    background: transparent;
}

.modal::-webkit-scrollbar-thumb {
    background: rgba(100, 100, 100, 0.3);
    border-radius: 10px;
    -webkit-transition: background 0.3s, transform 0.3s;
    transition: background 0.3s, transform 0.3s;
}

.modal::-webkit-scrollbar-thumb:hover {
    background: rgba(100, 100, 100, 0.6);
    transform: scaleX(1.2);
}

.modal::-webkit-scrollbar-thumb:active {
    background: rgba(100, 100, 100, 0.8);
}

@keyframes fadeOverlay {
    to {
        opacity: 1;
    }
}

@keyframes scaleUp {
    to {
        transform: scale(1);
        opacity: 1;
    }
}

.modal-close {
    position: absolute;
    top: 12px;
    right: 12px;
    background: #ff5f57;
    border: none;
    border-radius: 50%;
    width: 32px;
    height: 32px;
    font-size: 18px;
    color: white;
    cursor: pointer;
    display: flex;
    align-items: center;
    justify-content: center;
    transition: background 0.2s, transform 0.2s;
    box-shadow: 0 2px 6px rgba(0, 0, 0, 0.2);
}

.modal-close:hover {
    background: #ff3b30;
    transform: scale(1.1);
}

.modal-close:focus {
    outline: none;
    box-shadow: 0 0 0 3px rgba(255, 91, 87, 0.4);
}

/* Responsive */
@media (max-width:1100px) {
    .app {
        grid-template-columns: 200px 1fr;
    }

    .aside {
        grid-column: 1/-1;
    }
}

@media (max-width:820px) {
    .app {
        display: grid;
        grid-template-columns: 60px 3fr;
        /* ستون چپ sidebar، ستون راست main */
        gap: 12px;
        width: 100%;
        padding: 0 12px;
    }

    .sidebar {
        grid-column: 1 / 2;
        /* ستون چپ */
        width: 100%;
        border-radius: 16px;
        display: flex;
        flex-direction: column;
        gap: 8px;
    }

    .main {
        grid-column: 2 / 3;
        /* ستون راست */
        width: 100%;
        max-height: none;
        padding: 12px;
        border-radius: 16px;
    }

    .aside {
        grid-column: 2 / 3;
        /* جز main باشد */
    }

    .overview {
        grid-template-columns: 1fr;
        /* داخل main تک ستونه شود */
    }


}

@media (max-width:600px) {

}












/* سایر */
.hidden {
    display: none !important;
}

.actions-cell {
    display: flex;
    gap: 6px;
}

.truncate {
    display: inline-block;
    max-width: 200px;
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
}

.orange-gradient-button,
.export-excel-button {
    margin: 0;
}

.modal.fullscreen {
    width: 100vw;
    height: 100vh;
    max-width: 100%;
    max-height: 100%;
    top: 0;
    left: 0;
}



.icon-img {
    width: 24px;
    height: 24px;
    object-fit: contain;
}













.form__input-group {
    margin: 0 0 20px 0;
    width: 100%;
    position: relative;
    display: flex;
    flex-direction: column;
    gap: 15px;
}

.form__input-group:first-child {
    margin-top: 30px;
}

.form__input {
    width: 100%;
    padding: 14px 12px;
    border: 2px solid #a1a1a1;
    border-radius: 8px;
    transition: border 0.25s ease-in-out, box-shadow 0.25s ease-in-out;
    box-shadow: 0 2px 5px rgba(0, 0, 0, 0.05);
}

.form__input:focus {
    outline: none;
    border: 2px solid #EA6C22;
    box-shadow: 0 4px 12px rgba(234, 108, 34, 0.3);
}

.form__input:not(:placeholder-shown)~.form__input-label {
    top: 0;
    background-color: #ffffff;
    font-size: 14px;
    padding: 0 10px;
        color: #EA6C22;

    
}

.form__input-label {
  position: absolute;
  top: 50%;
  right: 12px;
  transform: translateY(-50%);
  transition: all 0.25s ease-in-out;
  pointer-events: none; /* ✅ */
}


/* حالت فوکوس */
.form__input:focus~.form__input-label {
    top: 0;
    background-color: #ffffff;
    font-size: 14px;
    padding: 0 10px;
    color: #EA6C22;

    
}


textarea:not(#paymentNote) {
    width: 100%;
    padding: 0.75rem 1rem;
    font-size: 16px;
    line-height: 1.5;
    color: #333;
    background-color: #fff;
    border: 1px solid #ccc;
    border-radius: 12px;
    outline: none;
    transition: all 0.2s ease-in-out;
    margin: 10px 0;

    &::placeholder {
        color: #999;
        font-size: 14px;
        text-align: right;
    }

    &:focus {
        border-color: #EA6C22;
        box-shadow: 0 0 0 3px rgba(76, 154, 255, 0.2);
    }

    &:disabled {
        background-color: #f5f5f5;
        border-color: #ddd;
        color: #999;
        cursor: not-allowed;
    }

    &.is-error {
        border-color: #e74c3c;
        box-shadow: 0 0 0 3px rgba(231, 76, 60, 0.2);
    }
}

#paymentNote {
    width: 100%;
    resize: vertical;
    min-height: 80px;
    padding: 0.75rem 1rem;
    border-radius: 12px;
}









/* بخش کلی مودال */
.modal-info-content {
  direction: rtl;
  text-align: right;
  padding: 1.5rem;
  font-size: 16px;
  color: #333;
  line-height: 1.8;
  background: #fff;
  border-radius: 12px;

}

/* عنوان مودال */
.modal-info-content .modal-title {
  font-size: 20px;
  font-weight: 700;
  color: #222;
  margin-bottom: 1.2rem;
  border-bottom: 2px solid #eee;
  padding-bottom: 0.5rem;
}

/* بخش اطلاعات */
.modal-info-content .modal-info {
  display: flex;
  flex-direction: column;
  gap: 0.6rem;
}

/* هر ردیف اطلاعات */
.modal-info-content .info-row {
  display: flex;
  align-items: flex-start;   
  background: #fafafa;
  border-radius: 8px;
  padding: 0.6rem 1rem;
  transition: background 0.3s ease;
  flex-wrap: wrap;         
}

.modal-info-content .info-row:hover {
  background: #f3f3f3;
}

/* برچسب (label) */
.modal-info-content .info-label {
  font-weight: 600;
  color: #444;
  font-size: 15px;
  position: relative;
  padding-right: 10px;
  margin-left: 6px;
}

/* نوار رنگی کنار label */
.modal-info-content .info-label::before {
  content: "";
  position: absolute;
  right: 0;
  top: 50%;
  transform: translateY(-50%);
  width: 3px;
  height: 70%;
  border-radius: 2px;
  background: linear-gradient(180deg, #ff8c00, #ff3c00);
  opacity: 0.8;
  transition: all 0.3s ease;
}

/* افکت hover برای label */
.modal-info-content .info-row:hover .info-label {
  color: #000;
}

.modal-info-content .info-row:hover .info-label::before {
  height: 90%;
  opacity: 1;
}

/* مقدار (value) */
/* مقدار (value) */
.modal-info-content .info-value {
  color: #111;
  font-size: 15px;
  font-weight: 500;
  letter-spacing: 0.2px;
  margin-right: 4px;
  flex: 1 1;                 
  word-break: break-word;   
  white-space: normal;       
}











/* ---------- انتخاب برندها در فرم ویزیتور ---------- */
.marketer-brand-select {
  margin-top: 16px;
}

.marketer-brand-select__label {
  display: block;
  font-size: 15px;
  color: #333;
  margin-bottom: 6px;
  font-weight: 500;
}

.marketer-brand-select__container {
  display: flex;
  flex-wrap: wrap;
  gap: 12px;
}

.marketer-brand-select__item {
  display: flex;
  align-items: center;
  gap: 6px;
  background-color: #f8f8f8;
  padding: 6px 12px;
  border-radius: 8px;
  cursor: pointer;
  transition: background-color 0.2s ease, box-shadow 0.2s ease;
  font-size: 14px;
  color: #444;
  -webkit-user-select: none;
          user-select: none;
}

.marketer-brand-select__item input[type="checkbox"] {
  accent-color: #ff7a00; /* رنگ نارنجی برند */
  width: 16px;
  height: 16px;
  cursor: pointer;
}

.marketer-brand-select__item:hover {
  background-color: #fff2e6;
  box-shadow: 0 0 4px rgba(255, 122, 0, 0.2);
}
`, "",{"version":3,"sources":["webpack://./src/pages/AdminPage/AdminPage.css"],"names":[],"mappings":"AAAA;IACI,qBAAqB;AACzB;;AAEA,sCAAsC;AACtC;IACI,aAAa;IACb,aAAa;IACb,SAAS;IACT,iBAAiB;IACjB,iBAAiB;IACjB,eAAe;AACnB;;AAEA,iBAAiB;AACjB;IACI,YAAY;IACZ,YAAY;IACZ,gBAAgB;IAChB,2BAA2B;IAC3B,gBAAgB;IAChB,aAAa;IACb,aAAa;IACb,mBAAmB;MACjB,2CAA2C;;AAEjD;;AAEA;IACI,mBAAmB;IACnB,mBAAmB;IACnB,aAAa;IACb,aAAa;IACb,sBAAsB;IACtB,QAAQ;IACR,YAAY;IACZ,2BAA2B;GAC5B,gBAAgB;EACjB,SAAS,EAAE,wBAAwB;IACjC,2CAA2C;;AAE/C;;;;AAIA;IACI,WAAW;AACf;;AAEA,yBAAyB;AACzB;EACE,uBAAuB;EACvB,MAAM;EACN,kBAAkB;AACpB;;AAEA,0BAA0B;AAC1B;EACE,UAAU;EACV,QAAQ;EACR,gBAAgB;EAChB,oCAAoC;AACtC;;AAEA,kBAAkB;AAClB;EACE,yBAAyB;EACzB,kBAAkB;EAClB,UAAU;EACV,QAAQ;EACR,2BAA2B;EAC3B,gBAAgB;EAChB,WAAW;EACX,gBAAgB;EAChB,kBAAkB;EAClB,mBAAmB;EACnB,eAAe;EACf,UAAU;EACV,oBAAoB;EACpB,kDAAkD;EAClD,gBAAgB;AAClB;;AAEA,yBAAyB;AACzB;EACE,UAAU;EACV,yCAAyC;AAC3C;;AAEA;IACI,mBAAmB;AACvB;;;AAGA,SAAS;AACT;IACI,aAAa;IACb,mBAAmB;IACnB,8BAA8B;IAC9B,SAAS;AACb;;AAEA;IACI,eAAe;AACnB;;AAEA;IACI,eAAe;IACf,mBAAmB;IACnB,gBAAgB;IAChB,uBAAuB;IACvB,wBAAwB;AAC5B;;AAEA;IACI,UAAU;AACd;;AAEA,qBAAqB;AACrB;IACI,gBAAgB;IAChB,YAAY;IACZ,eAAe;IACf,eAAe;AACnB;;AAEA,WAAW;AACX;IACI,aAAa;IACb,sBAAsB;IACtB,SAAS;IACT,sBAAsB;AAC1B;;AAEA;IACI,aAAa;IACb,mBAAmB;IACnB,SAAS;IACT,yBAAyB;IACzB,iBAAiB;IACjB,mBAAmB;IACnB,WAAW;IACX,qBAAqB;IACrB,2BAA2B;AAC/B;;;;AAIA;IACI,mBAAmB;IACnB,gBAAgB;IAChB,uBAAuB;IACvB,wBAAwB;AAC5B;;AAEA;IACI,UAAU;AACd;;;AAGA;IACI,yCAAyC;;IAEzC,YAAY;AAChB;;;;AAIA;IACI,eAAe;IACf,yBAAyB;IACzB,kBAAkB;;IAElB,aAAa;IACb,8BAA8B;IAC9B,mBAAmB;IACnB,uBAAuB;AAC3B;;AAEA;IACI,aAAa;AACjB;;AAEA;IACI,iDAAiD;IACjD,aAAa;IACb,mDAAmD;IACnD,wDAAwD;AAC5D;;AAEA;IACI,UAAU;IACV,0BAA0B;IAC1B,qBAAqB;IACrB,sBAAsB;IACtB,eAAe;IACf,sDAAsD;IACtD;4DACwD;AAC5D;;AAEA;IACI,uBAAuB;AAC3B;;AAEA;IACI,yBAAyB;AAC7B;;AAEA;IACI,wBAAwB;IACxB,yBAAyB;AAC7B;;;AAGA,iBAAiB;AACjB;IACI,aAAa;IACb,sBAAsB;IACtB,SAAS;AACb;;AAEA;IACI,aAAa;IACb,0BAA0B;IAC1B,SAAS;AACb;;AAEA;IACI,wBAAwB;IACxB,mBAAmB;IACnB,aAAa;AACjB;;AAEA,0CAA0C;AAC1C;EACE,aAAa;EACb,mBAAmB;EACnB,8BAA8B;EAC9B,mBAAmB;EACnB,eAAe,EAAE,mBAAmB;EACpC,SAAS;AACX;;AAEA,UAAU;AACV;EACE,iBAAiB;EACjB,gBAAgB;EAChB,WAAW;AACb;;AAEA,gCAAgC;AAChC;EACE,aAAa;EACb,mBAAmB;EACnB,SAAS;EACT,eAAe;AACjB;;;;AAIA;IACI,aAAa;IACb,UAAU;AACd;;AAEA;IACI,mBAAmB;IACnB,eAAe;AACnB;;AAEA,wBAAwB;AACxB;IACI,aAAa;IACb,mBAAmB;IACnB,SAAS;IACT,kBAAkB;AACtB;;AAEA;IACI,WAAW;IACX,YAAY;IACZ,mBAAmB;IACnB,mBAAmB;IACnB,aAAa;IACb,mBAAmB;IACnB,gBAAgB;AACpB;;AAEA;IACI,eAAe;IACf,SAAS;AACb;;AAEA;IACI,cAAc;IACd,kBAAkB;IAClB,mBAAmB;IACnB,aAAa;IACb,mBAAmB;IACnB,oBAAoB;IACpB,SAAS;IACT,yBAAyB;IACzB,eAAe;IACf,uCAAuC;AAC3C;;AAEA;IACI,aAAa;IACb,8BAA8B;IAC9B,mBAAmB;IACnB,uBAAuB;IACvB,eAAe;IACf,sCAAsC;AAC1C;;AAEA;IACI,qBAAqB;IACrB,eAAe;AACnB;;;;AAIA;IACI,UAAU;IACV,QAAQ;IACR,gBAAgB;IAChB,oCAAoC;AACxC;;AAEA;IACI,uCAAuC;IACvC,YAAY;AAChB;;;AAGA,UAAU;AACV;IACI,SAAO;IACP,kBAAkB;AACtB;;AAEA;IACI,WAAW;IACX,4BAA4B;IAC5B,oBAAoB;IACpB,6BAA6B;IAC7B,aAAa;IACb,gBAAgB;IAChB,4CAA4C;AAChD;;AAEA,YAAY;AACZ;IACI,SAAS;IACT,kBAAkB;IAClB,oBAAoB;IACpB,4BAA4B;IAC5B,WAAW;IACX,eAAe;IACf,gBAAgB;IAChB,2CAA2C;IAC3C,4BAA4B;IAC5B,eAAe;AACnB;;AAEA,SAAS;AACT;IACI,yBAAyB;IACzB,iBAAiB;IACjB,mBAAmB;IACnB,eAAe;IACf,oBAAoB;IACpB,mBAAmB;IACnB,QAAQ;IACR,yBAAiB;YAAjB,iBAAiB;IACjB,4BAA4B;IAC5B,kBAAkB;IAClB,gBAAgB;AACpB;;AAEA;IACI,eAAe;AACnB;;AAEA,aAAa;AACb;IACI,aAAa;IACb,8BAA8B;IAC9B,SAAS;AACb;;AAEA;IACI,gBAAgB;IAChB,mBAAmB;IACnB,aAAa;IACb,6BAA6B;AACjC;;AAEA;IACI,eAAe;IACf,gBAAgB;IAChB,oBAAoB;AACxB;;AAEA;IACI,oBAAoB;IACpB,mBAAmB;IACnB,QAAQ;IACR,gBAAgB;IAChB,gBAAgB;IAChB,mBAAmB;AACvB;;AAEA;IACI,mCAAmC;IACnC,mBAAmB;AACvB;;AAEA;IACI,kCAAkC;IAClC,iBAAiB;AACrB;;AAEA,SAAS;AACT;IACI,aAAa;IACb,qBAAqB;IACrB,SAAS;IACT,aAAa;IACb,aAAa;IACb,qDAAqD;IACrD,mBAAmB;IACnB,6BAA6B;AACjC;;AAEA;IACI,SAAO;IACP,mBAAmB;IACnB,mBAAmB;IACnB,kBAAkB;IAClB,gBAAgB;AACpB;;AAEA;IACI,kBAAkB;IAClB,SAAS;IACT,OAAO;IACP,QAAQ;IACR,cAAc;IACd,WAAW;IACX,qDAAqD;AACzD;;AAEA,YAAY;AACZ;IACI,aAAa;IACb,sBAAsB;IACtB,SAAS;AACb;;AAEA;IACI,aAAa;IACb,mBAAmB;IACnB,8BAA8B;IAC9B,SAAS;IACT,kBAAkB;IAClB,mBAAmB;IACnB,yBAAyB;IACzB,mBAAmB;AACvB;;AAEA;IACI,SAAO;IACP,qBAAqB;IACrB,gBAAgB;IAChB,mBAAmB;IACnB,gBAAgB;IAChB,uBAAuB;AAC3B;;AAEA;IACI,gBAAgB;IAChB,eAAe;IACf,kBAAkB;IAClB,YAAY;IACZ,4BAA4B;IAC5B,WAAW;IACX,eAAe;IACf,gBAAgB;IAChB,8CAA8C;AAClD;;AAEA,4BAA4B;AAC5B;;IAEI,gBAAgB;IAChB,UAAU;IACV,kBAAkB;AACtB;;;AAGA,UAAU;AACV;IACI,eAAe;IACf,MAAM;IACN,OAAO;IACP,QAAQ;IACR,SAAS;IACT,+BAA+B;IAC/B,0BAA0B;IAC1B,aAAa;IACb,uBAAuB;IACvB,mBAAmB;IACnB,YAAY;IACZ,UAAU;IACV,yCAAyC;IACzC,aAAa;IACb,sBAAsB;AAC1B;;AAEA;EACE,gBAAgB;EAChB,aAAa;EACb,mBAAmB;EACnB,UAAU;EACV,iBAAiB;EACjB,gBAAgB;EAChB,gBAAgB;EAChB,0CAA0C;EAC1C,2BAA2B;EAC3B,UAAU;EACV,+DAA+D;EAC/D,qBAAqB;EACrB,qDAAqD;AACvD;;AAEA,cAAc;AACd;EACE;IACE,2BAA2B;IAC3B,UAAU;EACZ;EACA;IACE,wBAAwB;IACxB,UAAU;EACZ;AACF;;;;AAIA;;;AAGA;;IAEI,WAAW;;AAEf;AACA;AACA;IACI,UAAU;AACd;;AAEA;IACI,uBAAuB;AAC3B;;AAEA;IACI,oCAAoC;IACpC,mBAAmB;IACnB,mDAA2C;IAA3C,2CAA2C;AAC/C;;AAEA;IACI,oCAAoC;IACpC,sBAAsB;AAC1B;;AAEA;IACI,oCAAoC;AACxC;;AAEA;IACI;QACI,UAAU;IACd;AACJ;;AAEA;IACI;QACI,mBAAmB;QACnB,UAAU;IACd;AACJ;;AAEA;IACI,kBAAkB;IAClB,SAAS;IACT,WAAW;IACX,mBAAmB;IACnB,YAAY;IACZ,kBAAkB;IAClB,WAAW;IACX,YAAY;IACZ,eAAe;IACf,YAAY;IACZ,eAAe;IACf,aAAa;IACb,mBAAmB;IACnB,uBAAuB;IACvB,2CAA2C;IAC3C,wCAAwC;AAC5C;;AAEA;IACI,mBAAmB;IACnB,qBAAqB;AACzB;;AAEA;IACI,aAAa;IACb,4CAA4C;AAChD;;AAEA,eAAe;AACf;IACI;QACI,gCAAgC;IACpC;;IAEA;QACI,iBAAiB;IACrB;AACJ;;AAEA;IACI;QACI,aAAa;QACb,+BAA+B;QAC/B,oCAAoC;QACpC,SAAS;QACT,WAAW;QACX,eAAe;IACnB;;IAEA;QACI,kBAAkB;QAClB,YAAY;QACZ,WAAW;QACX,mBAAmB;QACnB,aAAa;QACb,sBAAsB;QACtB,QAAQ;IACZ;;IAEA;QACI,kBAAkB;QAClB,cAAc;QACd,WAAW;QACX,gBAAgB;QAChB,aAAa;QACb,mBAAmB;IACvB;;IAEA;QACI,kBAAkB;QAClB,iBAAiB;IACrB;;IAEA;QACI,0BAA0B;QAC1B,2BAA2B;IAC/B;;;AAGJ;;AAEA;;AAEA;;;;;;;;;;;;;AAaA,SAAS;AACT;IACI,wBAAwB;AAC5B;;AAEA;IACI,aAAa;IACb,QAAQ;AACZ;;AAEA;IACI,qBAAqB;IACrB,gBAAgB;IAChB,mBAAmB;IACnB,gBAAgB;IAChB,uBAAuB;AAC3B;;AAEA;;IAEI,SAAS;AACb;;AAEA;IACI,YAAY;IACZ,aAAa;IACb,eAAe;IACf,gBAAgB;IAChB,MAAM;IACN,OAAO;AACX;;;;AAIA;IACI,WAAW;IACX,YAAY;IACZ,mBAAmB;AACvB;;;;;;;;;;;;;;AAcA;IACI,kBAAkB;IAClB,WAAW;IACX,kBAAkB;IAClB,aAAa;IACb,sBAAsB;IACtB,SAAS;AACb;;AAEA;IACI,gBAAgB;AACpB;;AAEA;IACI,WAAW;IACX,kBAAkB;IAClB,yBAAyB;IACzB,kBAAkB;IAClB,kEAAkE;IAClE,yCAAyC;AAC7C;;AAEA;IACI,aAAa;IACb,yBAAyB;IACzB,8CAA8C;AAClD;;AAEA;IACI,MAAM;IACN,yBAAyB;IACzB,eAAe;IACf,eAAe;QACX,cAAc;;;AAGtB;;AAEA;EACE,kBAAkB;EAClB,QAAQ;EACR,WAAW;EACX,2BAA2B;EAC3B,iCAAiC;EACjC,oBAAoB,EAAE,MAAM;AAC9B;;;AAGA,eAAe;AACf;IACI,MAAM;IACN,yBAAyB;IACzB,eAAe;IACf,eAAe;IACf,cAAc;;;AAGlB;;;AAGA;IACI,WAAW;IACX,qBAAqB;IACrB,eAAe;IACf,gBAAgB;IAChB,WAAW;IACX,sBAAsB;IACtB,sBAAsB;IACtB,mBAAmB;IACnB,aAAa;IACb,gCAAgC;IAChC,cAAc;;IAEd;QACI,WAAW;QACX,eAAe;QACf,iBAAiB;IACrB;;IAEA;QACI,qBAAqB;QACrB,6CAA6C;IACjD;;IAEA;QACI,yBAAyB;QACzB,kBAAkB;QAClB,WAAW;QACX,mBAAmB;IACvB;;IAEA;QACI,qBAAqB;QACrB,4CAA4C;IAChD;AACJ;;AAEA;IACI,WAAW;IACX,gBAAgB;IAChB,gBAAgB;IAChB,qBAAqB;IACrB,mBAAmB;AACvB;;;;;;;;;;AAUA,kBAAkB;AAClB;EACE,cAAc;EACd,iBAAiB;EACjB,eAAe;EACf,eAAe;EACf,WAAW;EACX,gBAAgB;EAChB,gBAAgB;EAChB,mBAAmB;;AAErB;;AAEA,gBAAgB;AAChB;EACE,eAAe;EACf,gBAAgB;EAChB,WAAW;EACX,qBAAqB;EACrB,6BAA6B;EAC7B,sBAAsB;AACxB;;AAEA,gBAAgB;AAChB;EACE,aAAa;EACb,sBAAsB;EACtB,WAAW;AACb;;AAEA,oBAAoB;AACpB;EACE,aAAa;EACb,uBAAuB;EACvB,mBAAmB;EACnB,kBAAkB;EAClB,oBAAoB;EACpB,gCAAgC;EAChC,eAAe;AACjB;;AAEA;EACE,mBAAmB;AACrB;;AAEA,kBAAkB;AAClB;EACE,gBAAgB;EAChB,WAAW;EACX,eAAe;EACf,kBAAkB;EAClB,mBAAmB;EACnB,gBAAgB;AAClB;;AAEA,yBAAyB;AACzB;EACE,WAAW;EACX,kBAAkB;EAClB,QAAQ;EACR,QAAQ;EACR,2BAA2B;EAC3B,UAAU;EACV,WAAW;EACX,kBAAkB;EAClB,qDAAqD;EACrD,YAAY;EACZ,yBAAyB;AAC3B;;AAEA,0BAA0B;AAC1B;EACE,WAAW;AACb;;AAEA;EACE,WAAW;EACX,UAAU;AACZ;;AAEA,kBAAkB;AAClB,kBAAkB;AAClB;EACE,WAAW;EACX,eAAe;EACf,gBAAgB;EAChB,qBAAqB;EACrB,iBAAiB;EACjB,SAAO;EACP,sBAAsB;EACtB,mBAAmB;AACrB;;;;;;;;;;;;AAYA,uDAAuD;AACvD;EACE,gBAAgB;AAClB;;AAEA;EACE,cAAc;EACd,eAAe;EACf,WAAW;EACX,kBAAkB;EAClB,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,eAAe;EACf,SAAS;AACX;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,QAAQ;EACR,yBAAyB;EACzB,iBAAiB;EACjB,kBAAkB;EAClB,eAAe;EACf,4DAA4D;EAC5D,eAAe;EACf,WAAW;EACX,yBAAiB;UAAjB,iBAAiB;AACnB;;AAEA;EACE,qBAAqB,EAAE,oBAAoB;EAC3C,WAAW;EACX,YAAY;EACZ,eAAe;AACjB;;AAEA;EACE,yBAAyB;EACzB,0CAA0C;AAC5C","sourcesContent":["a {\n    text-decoration: none;\n}\n\n/* ---------- ساختار اصلی ---------- */\n.app {\n    padding: 16px;\n    display: flex;\n    gap: 16px;\n    max-width: 1400px;\n    margin: 32px auto;\n    padding: 0 12px;\n}\n\n/* Main content */\n.main {\n    flex-grow: 1;\n    height: auto;\n    max-height: 90vh;\n    transition: width 0.3s ease;\n    background: #fff;\n    padding: 16px;\n    width: 1100px;\n    border-radius: 20px;\n      box-shadow: 0 10px 25px rgba(0, 0, 0, 0.05);\n\n}\n\n.sidebar {\n    background: #ffffff;\n    border-radius: 20px;\n    padding: 12px;\n    display: flex;\n    flex-direction: column;\n    gap: 8px;\n    width: 250px;\n    transition: width 0.3s ease;\n   position: sticky;\n  top: 20px; /* فاصله از بالای صفحه */\n    box-shadow: 0 10px 25px rgba(0, 0, 0, 0.05);\n\n}\n\n\n\n.sidebar.closed {\n    width: 60px;\n}\n\n/* وقتی سایدبار بسته شد */\n.sidebar.closed .nav a {\n  justify-content: center;\n  gap: 0;\n  position: relative; \n}\n\n/* متن label مخفی می‌شود */\n.sidebar.closed .nav a .label {\n  opacity: 0;\n  width: 0;\n  overflow: hidden;\n  transition: opacity 0.3s, width 0.3s;\n}\n\n/* استایل تولتیپ */\n.sidebar.closed .nav a::after {\n  content: attr(data-label); \n  position: absolute;\n  left: 100%;  \n  top: 50%;\n  transform: translateY(-50%);\n  background: #333;\n  color: #fff;\n  padding: 4px 8px;\n  border-radius: 4px;\n  white-space: nowrap;\n  font-size: 12px;\n  opacity: 0;\n  pointer-events: none;\n  transition: opacity 0.3s ease, transform 0.3s ease;\n  margin-left: 8px; \n}\n\n/* نمایش تولتیپ در هاور */\n.sidebar.closed .nav a:hover::after {\n  opacity: 1;\n  transform: translateY(-50%) translateX(0);\n}\n\n.sidebar.closed .toggle-btn {\n    margin-right: -10px;\n}\n\n\n/* برند */\n.brand {\n    display: flex;\n    align-items: center;\n    justify-content: space-between;\n    gap: 10px;\n}\n\n.brand .logo {\n    font-size: 24px;\n}\n\n.brand h1 {\n    font-size: 16px;\n    white-space: nowrap;\n    overflow: hidden;\n    text-overflow: ellipsis;\n    transition: opacity 0.3s;\n}\n\n.brand h1.hidden {\n    opacity: 0;\n}\n\n/* دکمه تغییر وضعیت */\n.toggle-btn {\n    background: none;\n    border: none;\n    cursor: pointer;\n    font-size: 20px;\n}\n\n/* ناوبری */\n.nav {\n    display: flex;\n    flex-direction: column;\n    gap: 12px;\n    /* فاصله بین لینک‌ها */\n}\n\n.nav a {\n    display: flex;\n    align-items: center;\n    gap: 12px;\n    /* فاصله بین آیکن و متن */\n    padding: 8px 12px;\n    border-radius: 12px;\n    color: #333;\n    text-decoration: none;\n    transition: background 0.2s;\n}\n\n\n\n.nav a .label {\n    white-space: nowrap;\n    overflow: hidden;\n    text-overflow: ellipsis;\n    transition: opacity 0.3s;\n}\n\n.sidebar.closed .nav a .label {\n    opacity: 0;\n}\n\n\n.nav a:hover {\n    background-color: rgba(234, 108, 34, 0.7);\n\n    color: #ffff;\n}\n\n\n\n.hamburger {\n    cursor: pointer;\n    background-color: #EA6C22;\n    border-radius: 8px;\n\n    display: flex;\n    /* برای هم‌ترازی محتوای آیکن */\n    align-items: center;\n    justify-content: center;\n}\n\n.hamburger input {\n    display: none;\n}\n\n.hamburger svg {\n    /* The size of the SVG defines the overall size */\n    height: 1.5em;\n    /* Define the transition for transforming the SVG */\n    transition: transform 600ms cubic-bezier(0.4, 0, 0.2, 1);\n}\n\n.line {\n    fill: none;\n    stroke: rgb(255, 255, 255);\n    stroke-linecap: round;\n    stroke-linejoin: round;\n    stroke-width: 3;\n    /* Define the transition for transforming the Stroke */\n    transition: stroke-dasharray 600ms cubic-bezier(0.4, 0, 0.2, 1),\n        stroke-dashoffset 600ms cubic-bezier(0.4, 0, 0.2, 1);\n}\n\n.line-top-bottom {\n    stroke-dasharray: 12 63;\n}\n\n.hamburger input:checked+svg {\n    transform: rotate(-45deg);\n}\n\n.hamburger input:checked+svg .line-top-bottom {\n    stroke-dasharray: 20 300;\n    stroke-dashoffset: -32.42;\n}\n\n\n/* Aside & Grid */\n.aside {\n    display: flex;\n    flex-direction: column;\n    gap: 16px;\n}\n\n.grid {\n    display: grid;\n    grid-template-columns: 1fr;\n    gap: 16px;\n}\n\n.card {\n    background: var(--panel);\n    border-radius: 20px;\n    padding: 16px;\n}\n\n/* ---------- ساختار اصلی هدر ---------- */\n.card-header {\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n  margin-bottom: 12px;\n  flex-wrap: wrap; /* برای ریسپانسیو */\n  gap: 1rem;\n}\n\n/* عنوان */\n.card-header .card-title {\n  font-size: 1.3rem;\n  font-weight: 600;\n  color: #222;\n}\n\n/* بخش راست شامل سرچ و دکمه‌ها */\n.header-actions {\n  display: flex;\n  align-items: center;\n  gap: 1rem;\n  flex-wrap: wrap;\n}\n\n\n\n.button-group {\n    display: flex;\n    gap: 8px !;\n}\n\n.muted {\n    color: var(--muted);\n    font-size: 12px;\n}\n\n/* برند و ناوبری عمومی */\n.brand {\n    display: flex;\n    align-items: center;\n    gap: 10px;\n    padding: 10px 12px;\n}\n\n.brand .logo {\n    width: 34px;\n    height: 34px;\n    border-radius: 12px;\n    background: #e5e7eb;\n    display: grid;\n    place-items: center;\n    font-weight: 700;\n}\n\n.brand h1 {\n    font-size: 20px;\n    margin: 0;\n}\n\n.nav a {\n    color: #111827;\n    padding: 10px 12px;\n    border-radius: 12px;\n    display: flex;\n    align-items: center;\n    /* مرکز کردن عمودی */\n    gap: 12px;\n    /* فاصله بین آیکن و متن */\n    cursor: pointer;\n    transition: color 0.3s, background 0.3s;\n}\n\n.nav a .dot {\n    display: flex;\n    /* برای هم‌ترازی محتوای آیکن */\n    align-items: center;\n    justify-content: center;\n    font-size: 20px;\n    /* سایز آیکن را می‌توانید تنظیم کنید */\n}\n\n.nav a .label {\n    display: inline-block;\n    font-size: 16px;\n}\n\n\n\n.sidebar.closed .nav a .label {\n    opacity: 0;\n    width: 0;\n    overflow: hidden;\n    transition: opacity 0.3s, width 0.3s;\n}\n\n.nav a.active {\n    background-color: rgba(234, 108, 34, 1);\n    color: white;\n}\n\n\n/* جستجو */\n.search {\n    flex: 1;\n    position: relative;\n}\n\n.search input {\n    width: 100%;\n    padding: 12px 44px 12px 16px;\n    border-radius: 999px;\n    border: 1px solid var(--ring);\n    outline: none;\n    background: #fff;\n    box-shadow: inset 0 1px 0 rgba(0, 0, 0, .03);\n}\n\n/* دکمه‌ها */\n.btn {\n    border: 0;\n    padding: 10px 16px;\n    border-radius: 999px;\n    background: var(--mainColor);\n    color: #fff;\n    cursor: pointer;\n    font-weight: 600;\n    box-shadow: 0 8px 18px rgba(17, 24, 39, .2);\n    font-family: Estedad-Regular;\n    font-size: 13px;\n}\n\n/* Pill */\n.pill {\n    background-color: #f0f0f0;\n    padding: 8px 15px;\n    border-radius: 25px;\n    cursor: pointer;\n    display: inline-flex;\n    align-items: center;\n    gap: 5px;\n    user-select: none;\n    font-family: Estedad-Regular;\n    position: relative;\n    min-width: 120px;\n}\n\n.pill .arrow {\n    font-size: 12px;\n}\n\n/* Overview */\n.overview {\n    display: grid;\n    grid-template-columns: 1fr 1fr;\n    gap: 12px;\n}\n\n.stat {\n    background: #fff;\n    border-radius: 16px;\n    padding: 18px;\n    border: 1px solid var(--ring);\n}\n\n.stat .value {\n    font-size: 44px;\n    font-weight: 800;\n    letter-spacing: -1px;\n}\n\n.delta {\n    display: inline-flex;\n    align-items: center;\n    gap: 6px;\n    font-weight: 600;\n    padding: 6px 8px;\n    border-radius: 10px;\n}\n\n.delta.up {\n    background: rgba(16, 185, 129, .12);\n    color: var(--green);\n}\n\n.delta.down {\n    background: rgba(239, 68, 68, .12);\n    color: var(--red);\n}\n\n/* Bars */\n.bars {\n    display: flex;\n    align-items: flex-end;\n    gap: 10px;\n    height: 180px;\n    padding: 16px;\n    background: linear-gradient(180deg, #fafafb, #f7f7f8);\n    border-radius: 16px;\n    border: 1px solid var(--ring);\n}\n\n.bar {\n    flex: 1;\n    background: #e5e7eb;\n    border-radius: 12px;\n    position: relative;\n    overflow: hidden;\n}\n\n.bar>i {\n    position: absolute;\n    bottom: 0;\n    left: 0;\n    right: 0;\n    display: block;\n    height: 60%;\n    background: linear-gradient(180deg, #a7f3d0, #34d399);\n}\n\n/* Vendors */\n.vendors {\n    display: flex;\n    flex-direction: column;\n    gap: 12px;\n}\n\n.vendor {\n    display: flex;\n    align-items: center;\n    justify-content: space-between;\n    gap: 16px;\n    padding: 12px 16px;\n    border-radius: 12px;\n    border: 1px solid #e5e7eb;\n    background: #f9fafb;\n}\n\n.vendor .title {\n    flex: 2;\n    display: inline-block;\n    max-width: 200px;\n    white-space: nowrap;\n    overflow: hidden;\n    text-overflow: ellipsis;\n}\n\n.vendor .edit-product {\n    padding: 4px 8px;\n    font-size: 12px;\n    border-radius: 8px;\n    border: none;\n    background: var(--mainColor);\n    color: #fff;\n    cursor: pointer;\n    margin-left: 8px;\n    box-shadow: 0 4px 10px rgba(59, 130, 246, 0.3);\n}\n\n/* Product & Visitor Lists */\n.product-list-bnv,\n.visitor-list-bnv {\n    list-style: none;\n    padding: 0;\n    margin: 0 0 15px 0;\n}\n\n\n/* Modal */\n.modal-overlay {\n    position: fixed;\n    top: 0;\n    left: 0;\n    right: 0;\n    bottom: 0;\n    background: rgba(0, 0, 0, 0.25);\n    backdrop-filter: blur(5px);\n    display: flex;\n    justify-content: center;\n    align-items: center;\n    z-index: 999;\n    opacity: 0;\n    animation: fadeOverlay 0.4s ease forwards;\n    padding: 20px;\n    box-sizing: border-box;\n}\n\n.modal {\n  background: #fff;\n  padding: 20px;\n  border-radius: 16px;\n  width: 50%;\n  max-width: 4000px;\n  max-height: 90vh;\n  overflow-y: auto;\n  box-shadow: 0 10px 30px rgba(0, 0, 0, 0.2);\n  transform: translateY(50px);\n  opacity: 0;\n  animation: slideUp 0.5s cubic-bezier(0.22, 1, 0.36, 1) forwards;\n  scrollbar-width: thin;\n  scrollbar-color: rgba(100, 100, 100, 0.5) transparent;\n}\n\n/* Animation */\n@keyframes slideUp {\n  0% {\n    transform: translateY(50px);\n    opacity: 0;\n  }\n  100% {\n    transform: translateY(0);\n    opacity: 1;\n  }\n}\n\n\n\n@media (max-width: 768px) {\n\n  \n.modal {\n\n    width: 100%;\n\n}\n}\n.modal::-webkit-scrollbar {\n    width: 6px;\n}\n\n.modal::-webkit-scrollbar-track {\n    background: transparent;\n}\n\n.modal::-webkit-scrollbar-thumb {\n    background: rgba(100, 100, 100, 0.3);\n    border-radius: 10px;\n    transition: background 0.3s, transform 0.3s;\n}\n\n.modal::-webkit-scrollbar-thumb:hover {\n    background: rgba(100, 100, 100, 0.6);\n    transform: scaleX(1.2);\n}\n\n.modal::-webkit-scrollbar-thumb:active {\n    background: rgba(100, 100, 100, 0.8);\n}\n\n@keyframes fadeOverlay {\n    to {\n        opacity: 1;\n    }\n}\n\n@keyframes scaleUp {\n    to {\n        transform: scale(1);\n        opacity: 1;\n    }\n}\n\n.modal-close {\n    position: absolute;\n    top: 12px;\n    right: 12px;\n    background: #ff5f57;\n    border: none;\n    border-radius: 50%;\n    width: 32px;\n    height: 32px;\n    font-size: 18px;\n    color: white;\n    cursor: pointer;\n    display: flex;\n    align-items: center;\n    justify-content: center;\n    transition: background 0.2s, transform 0.2s;\n    box-shadow: 0 2px 6px rgba(0, 0, 0, 0.2);\n}\n\n.modal-close:hover {\n    background: #ff3b30;\n    transform: scale(1.1);\n}\n\n.modal-close:focus {\n    outline: none;\n    box-shadow: 0 0 0 3px rgba(255, 91, 87, 0.4);\n}\n\n/* Responsive */\n@media (max-width:1100px) {\n    .app {\n        grid-template-columns: 200px 1fr;\n    }\n\n    .aside {\n        grid-column: 1/-1;\n    }\n}\n\n@media (max-width:820px) {\n    .app {\n        display: grid;\n        grid-template-columns: 60px 3fr;\n        /* ستون چپ sidebar، ستون راست main */\n        gap: 12px;\n        width: 100%;\n        padding: 0 12px;\n    }\n\n    .sidebar {\n        grid-column: 1 / 2;\n        /* ستون چپ */\n        width: 100%;\n        border-radius: 16px;\n        display: flex;\n        flex-direction: column;\n        gap: 8px;\n    }\n\n    .main {\n        grid-column: 2 / 3;\n        /* ستون راست */\n        width: 100%;\n        max-height: none;\n        padding: 12px;\n        border-radius: 16px;\n    }\n\n    .aside {\n        grid-column: 2 / 3;\n        /* جز main باشد */\n    }\n\n    .overview {\n        grid-template-columns: 1fr;\n        /* داخل main تک ستونه شود */\n    }\n\n\n}\n\n@media (max-width:600px) {\n\n}\n\n\n\n\n\n\n\n\n\n\n\n\n/* سایر */\n.hidden {\n    display: none !important;\n}\n\n.actions-cell {\n    display: flex;\n    gap: 6px;\n}\n\n.truncate {\n    display: inline-block;\n    max-width: 200px;\n    white-space: nowrap;\n    overflow: hidden;\n    text-overflow: ellipsis;\n}\n\n.orange-gradient-button,\n.export-excel-button {\n    margin: 0;\n}\n\n.modal.fullscreen {\n    width: 100vw;\n    height: 100vh;\n    max-width: 100%;\n    max-height: 100%;\n    top: 0;\n    left: 0;\n}\n\n\n\n.icon-img {\n    width: 24px;\n    height: 24px;\n    object-fit: contain;\n}\n\n\n\n\n\n\n\n\n\n\n\n\n\n.form__input-group {\n    margin: 0 0 20px 0;\n    width: 100%;\n    position: relative;\n    display: flex;\n    flex-direction: column;\n    gap: 15px;\n}\n\n.form__input-group:first-child {\n    margin-top: 30px;\n}\n\n.form__input {\n    width: 100%;\n    padding: 14px 12px;\n    border: 2px solid #a1a1a1;\n    border-radius: 8px;\n    transition: border 0.25s ease-in-out, box-shadow 0.25s ease-in-out;\n    box-shadow: 0 2px 5px rgba(0, 0, 0, 0.05);\n}\n\n.form__input:focus {\n    outline: none;\n    border: 2px solid #EA6C22;\n    box-shadow: 0 4px 12px rgba(234, 108, 34, 0.3);\n}\n\n.form__input:not(:placeholder-shown)~.form__input-label {\n    top: 0;\n    background-color: #ffffff;\n    font-size: 14px;\n    padding: 0 10px;\n        color: #EA6C22;\n\n    \n}\n\n.form__input-label {\n  position: absolute;\n  top: 50%;\n  right: 12px;\n  transform: translateY(-50%);\n  transition: all 0.25s ease-in-out;\n  pointer-events: none; /* ✅ */\n}\n\n\n/* حالت فوکوس */\n.form__input:focus~.form__input-label {\n    top: 0;\n    background-color: #ffffff;\n    font-size: 14px;\n    padding: 0 10px;\n    color: #EA6C22;\n\n    \n}\n\n\ntextarea:not(#paymentNote) {\n    width: 100%;\n    padding: 0.75rem 1rem;\n    font-size: 16px;\n    line-height: 1.5;\n    color: #333;\n    background-color: #fff;\n    border: 1px solid #ccc;\n    border-radius: 12px;\n    outline: none;\n    transition: all 0.2s ease-in-out;\n    margin: 10px 0;\n\n    &::placeholder {\n        color: #999;\n        font-size: 14px;\n        text-align: right;\n    }\n\n    &:focus {\n        border-color: #EA6C22;\n        box-shadow: 0 0 0 3px rgba(76, 154, 255, 0.2);\n    }\n\n    &:disabled {\n        background-color: #f5f5f5;\n        border-color: #ddd;\n        color: #999;\n        cursor: not-allowed;\n    }\n\n    &.is-error {\n        border-color: #e74c3c;\n        box-shadow: 0 0 0 3px rgba(231, 76, 60, 0.2);\n    }\n}\n\n#paymentNote {\n    width: 100%;\n    resize: vertical;\n    min-height: 80px;\n    padding: 0.75rem 1rem;\n    border-radius: 12px;\n}\n\n\n\n\n\n\n\n\n\n/* بخش کلی مودال */\n.modal-info-content {\n  direction: rtl;\n  text-align: right;\n  padding: 1.5rem;\n  font-size: 16px;\n  color: #333;\n  line-height: 1.8;\n  background: #fff;\n  border-radius: 12px;\n\n}\n\n/* عنوان مودال */\n.modal-info-content .modal-title {\n  font-size: 20px;\n  font-weight: 700;\n  color: #222;\n  margin-bottom: 1.2rem;\n  border-bottom: 2px solid #eee;\n  padding-bottom: 0.5rem;\n}\n\n/* بخش اطلاعات */\n.modal-info-content .modal-info {\n  display: flex;\n  flex-direction: column;\n  gap: 0.6rem;\n}\n\n/* هر ردیف اطلاعات */\n.modal-info-content .info-row {\n  display: flex;\n  align-items: flex-start;   \n  background: #fafafa;\n  border-radius: 8px;\n  padding: 0.6rem 1rem;\n  transition: background 0.3s ease;\n  flex-wrap: wrap;         \n}\n\n.modal-info-content .info-row:hover {\n  background: #f3f3f3;\n}\n\n/* برچسب (label) */\n.modal-info-content .info-label {\n  font-weight: 600;\n  color: #444;\n  font-size: 15px;\n  position: relative;\n  padding-right: 10px;\n  margin-left: 6px;\n}\n\n/* نوار رنگی کنار label */\n.modal-info-content .info-label::before {\n  content: \"\";\n  position: absolute;\n  right: 0;\n  top: 50%;\n  transform: translateY(-50%);\n  width: 3px;\n  height: 70%;\n  border-radius: 2px;\n  background: linear-gradient(180deg, #ff8c00, #ff3c00);\n  opacity: 0.8;\n  transition: all 0.3s ease;\n}\n\n/* افکت hover برای label */\n.modal-info-content .info-row:hover .info-label {\n  color: #000;\n}\n\n.modal-info-content .info-row:hover .info-label::before {\n  height: 90%;\n  opacity: 1;\n}\n\n/* مقدار (value) */\n/* مقدار (value) */\n.modal-info-content .info-value {\n  color: #111;\n  font-size: 15px;\n  font-weight: 500;\n  letter-spacing: 0.2px;\n  margin-right: 4px;\n  flex: 1;                 \n  word-break: break-word;   \n  white-space: normal;       \n}\n\n\n\n\n\n\n\n\n\n\n\n/* ---------- انتخاب برندها در فرم ویزیتور ---------- */\n.marketer-brand-select {\n  margin-top: 16px;\n}\n\n.marketer-brand-select__label {\n  display: block;\n  font-size: 15px;\n  color: #333;\n  margin-bottom: 6px;\n  font-weight: 500;\n}\n\n.marketer-brand-select__container {\n  display: flex;\n  flex-wrap: wrap;\n  gap: 12px;\n}\n\n.marketer-brand-select__item {\n  display: flex;\n  align-items: center;\n  gap: 6px;\n  background-color: #f8f8f8;\n  padding: 6px 12px;\n  border-radius: 8px;\n  cursor: pointer;\n  transition: background-color 0.2s ease, box-shadow 0.2s ease;\n  font-size: 14px;\n  color: #444;\n  user-select: none;\n}\n\n.marketer-brand-select__item input[type=\"checkbox\"] {\n  accent-color: #ff7a00; /* رنگ نارنجی برند */\n  width: 16px;\n  height: 16px;\n  cursor: pointer;\n}\n\n.marketer-brand-select__item:hover {\n  background-color: #fff2e6;\n  box-shadow: 0 0 4px rgba(255, 122, 0, 0.2);\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
